import React from 'react';
import { node, oneOfType, string } from 'prop-types';

const BreadcrumbItem = ({ children, ...props }) => <li {...props}>{children}</li>;

BreadcrumbItem.propTypes = {
  children: oneOfType([node, string]),
};

BreadcrumbItem.defaultProps = {
  children: null,
};

export default BreadcrumbItem;
